<template>
  <vs-popup class="popup-daily-safe-work-permit" title="일 안전작업허가서 불러오기" :active.sync="showPopup">
    <vs-tabs ref="tabs" v-model="activeTab" @input="() => {
      page = 1;
      loadPost();
    }">
      <vs-tab v-for="tab in tabs" :label="tab.label" ></vs-tab>
    </vs-tabs>

    <search-tools ref="searchTools" :boardId="976" layout="filter" v-model="nav" :options="searchOptions" @search="loadPost">
      <slot name="search"></slot>
    </search-tools>

    <vs-select class="mt-6" v-model="perPage" autocomplete style="width: 120px;" @change="loadPost">
      <vs-select-item v-for="i in [10, 20, 50, 100]" :key="i" :text="`${i}개씩 보기`" :value="i" />
    </vs-select>

    <div class="mt-4 overflow-x-auto">
      <vs-table
        class="w-full mb-4"
        stripe
        :sst="true"
        :max-items="perPage"
        :data="list"
        noDataText="데이터가 없습니다"
        @selected="(item) => {
          if (item.tbmUsed) {
            return;
          }

          if (selectPost === item) {
            onClickUse();
          } else {
            selectPost = item;
          }
        }"
      >
        <template slot="thead">
          <vs-th><span class="w-full text-center">No.</span></vs-th>
          <vs-th style="min-width: 100px;"><span class="w-full text-center">사업장명</span></vs-th>
          <vs-th style="min-width: 100px;"><span class="w-full text-center">상태</span></vs-th>
          <vs-th style="min-width: 80px;"><span class="w-full text-center">시작시간</span></vs-th>
          <vs-th style="min-width: 80px;"><span class="w-full text-center">종료시간</span></vs-th>
          <vs-th style="min-width: 90px;"><span class="w-full text-center">TBM 여부</span></vs-th>
          <vs-th style="min-width: 100px;"><span class="w-full text-center">구분</span></vs-th>
          <vs-th style="min-width: 150px;"><span class="w-full text-center">업체명</span></vs-th>
          <vs-th style="min-width: 180px;"><span class="w-full text-center">작업허가명</span></vs-th>
          <vs-th style="min-width: 180px;"><span class="w-full text-center">허가번호</span></vs-th>
          <vs-th style="min-width: 100px;"><span class="w-full text-center">승인권자<br>(관리감독자)</span></vs-th>
          <vs-th style="min-width: 150px;"><span class="w-full text-center">작업장소</span></vs-th>
          <vs-th style="min-width: 180px;"><span class="w-full text-center">작업내용</span></vs-th>
          <vs-th style="min-width: 180px;"><span class="w-full text-center">작업유형</span></vs-th>
          <vs-th style="min-width: 100px;"><span class="w-full text-center">확인<br>(안환팀)</span></vs-th>
          <vs-th style="min-width: 120px;"><span class="w-full text-center">연장작업</span></vs-th>
          <vs-th style="min-width: 120px;"><span class="w-full text-center">작성자</span></vs-th>
        </template>

        <template slot-scope="{data}">
          <vs-tr v-for="(tr, tr_i) in data" :key="`popup-q-r-history-${tr_i}`" :data="tr"
                 :class="[selectPost === tr && 'active', tr.tbmUsed && 'disabled']">
            <vs-td align="center">{{ total - ((page - 1) * perPage + tr_i)  }}</vs-td>
            <vs-td align="center">{{ tr['사업장명'] }}</vs-td>
            <vs-td align="center">
              <div class="color-box">
                <div class="flex items-center justify-center">
                  <p :style="tr['상태'].color ? `background:${tr['상태'].color}` : ''" :class="tr['상태'].color ? `text-white` : ''" style="font-size: 14px; font-weight: 500; text-align: center; padding: 2px 7px; border-radius: 4px">
                    {{ tr['상태'].text }}
                  </p>
                </div>
              </div>
            </vs-td>
            <vs-td align="center">{{ tr['시작시간'] }}</vs-td>
            <vs-td align="center">{{ tr['종료시간'] }}</vs-td>
            <vs-td align="center" v-html="tr.tbmHtml"></vs-td>
            <vs-td align="center">{{ tr['구분'] }}</vs-td>
            <vs-td align="center">{{ tr['업체명'] }}</vs-td>
            <vs-td align="center">{{ tr['작업허가명'] }}</vs-td>
            <vs-td align="center">{{ tr['허가번호'] }}</vs-td>
            <vs-td align="center">{{ tr['관리감독자'] }}</vs-td>
            <vs-td align="center">{{ tr['작업장소'] }}</vs-td>
            <vs-td align="center">{{ tr['작업내용'] }}</vs-td>
            <vs-td align="center">{{ tr['작업유형'] }}</vs-td>
            <vs-td align="center">{{ tr['안환팀'] }}</vs-td>
            <vs-td align="center">{{ tr['연장작업'] }}</vs-td>
            <vs-td align="center">{{ tr['작성자'] }}</vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </div>
    <div class="vs-con-table">
      <div class="con-pagination-table vs-table--pagination">
        <k-pagination :total="lastPage ? lastPage : 1" v-model="page" @change="loadPost"></k-pagination>
      </div>
    </div>

    <div class="mt-8 flex justify-end gap-4">
      <vs-button color="secondary" type="border" @click="onClickClose">닫기</vs-button>
      <vs-button color="secondary" @click="onClickUse">등록</vs-button>
    </div>
  </vs-popup>
</template>

<script>
import SearchNav from "@/components/nav/SearchNav.vue";
import KPagination from "@/components/kPagination/kPagination.vue";
import SearchTools from "@/views/list/components/SearchTools.vue";
import singlePageList from "@/views/boards/single-page/listIndex";

export default {
  name: "PopupDailySafeWorkPermit",
  components: { SearchTools, KPagination, SearchNav },
  props: {
    value: Boolean,
    searchDate: String,
  },
  computed: {
    showPopup: {
      get() {
        return this.value;
      },
      set(data) {
        this.$emit("input", data);
      },
    },
    projectId() {
      return parseInt(this.$route.params.proj_id);
    },
    tabs() {
      const tabs = []
      if (this.myBoardIds.includes(976)) {
        tabs.push({ label: "외부공사·작업", boardId: 976 });
      }
      if (this.myBoardIds.includes(981)) {
        tabs.push({ label: "내부작업(직영)", boardId: 981 });
      }
      if (this.myBoardIds.includes(986)) {
        tabs.push({ label: "내부작업(사내수급)", boardId: 986 });
      }
      return tabs;
    },
    myBoardIds() {
      return this.$store.state.menu.availableBoardIds;
    },
    searchOptions () {
      return [
        {
          'label': '작업시작일',
          'options': {
            default: {sd: this.searchDate || '', ed: this.searchDate || ''},
            readonly: true,
          }
        }
      ]
    }
  },
  watch: {
    value(value) {
      if (value) {
        this.activeTab = 0;
        this.loadPost();
      }
    },
  },
  data () {
    return {
      activeTab: 1, // 팝업이 켜진 상태에서 탭을 변경하면 탭바가 나오지 않는 문제가 있어서 초기값을 1로 설정
      page: 1,
      perPage: 20,
      lastPage: 1,
      total: 0,

      list: [],
      selectPost: null,
      nav: {

      }
    }
  },
  methods: {
    loadPost() {
      if (this.showPopup) {
        const options = {
          projectId: this.projectId,
          page: this.page,
          perPage: this.perPage,
          orderTarget: "created_at",
          orderDirection: 'desc',
        };

        // 데이터 로드
        if (this.tabs[this.activeTab].boardId === 976) {
          // 외부공사·작업
          this.loadPost976(options);
        }
        if (this.tabs[this.activeTab].boardId === 981) {
          // 내부작업(직영)
          this.loadPost981(options);
        }
        if (this.tabs[this.activeTab].boardId === 986) {
          // 내부작업(사내수급)
          this.loadPost986(options);
        }
      }
    },
    async loadPost976(options) {
      options.boardId = 976;
      const func = singlePageList[`${options.boardId}_list`] && singlePageList[`${options.boardId}_list`].getConditions;
      if (func) {
        options.conditions = func({ value: this.nav });
      }
      let response = await this.$store.dispatch("board/LOAD_POST_LIST", options);
      response = await this.prefixFunc(this, response, options);
      this.list = this.convertList(response);
    },
    async loadPost981(options) {
      options.boardId = 981;
      const func = singlePageList[`${options.boardId}_list`] && singlePageList[`${options.boardId}_list`].getConditions;
      if (func) {
        options.conditions = func({ value: this.nav });
      }
      let response = await this.$store.dispatch("board/LOAD_POST_LIST", options);
      response = await this.prefixFunc(this, response, options);
      this.list = this.convertList(response);
    },
    async loadPost986(options) {
      options.boardId = 986;
      const func = singlePageList[`${options.boardId}_list`] && singlePageList[`${options.boardId}_list`].getConditions;
      if (func) {
        options.conditions = func({ value: this.nav });
      }
      let response = await this.$store.dispatch("board/LOAD_POST_LIST", options);
      response = await this.prefixFunc(this, response, options);
      this.list = this.convertList(response);
    },

    prefixFunc: async (vue, response, options) => {
      const postIds = response.data.map(data => data.id);

      if (postIds && postIds.length > 0) {
        const conditions = [];
        conditions.push({key: 'body.TBM정보.postId', operator: 'IN', value: postIds})
        const res = await vue.$store.dispatch("board/LOAD_POST_LIST", {
          projectId: options.projectId,
          boardId: 830,
          page: 1,
          perPage: options.perPage,
          orderTarget: "created_at",
          orderDirection: "desc",
          conditions,
        });

        const tbmList = res && res.data && res.data.length > 0 ? res.data.map(data => JSON.parse(data.post_content)) : [];
        const tbmJson = {};
        for (let i=0; i<tbmList.length; i++) {
          const postId = tbmList[i].body.TBM정보.postId;
          if (postId) {
            tbmJson[postId] = tbmList[i];
          }
        }

        // response.data 에 tbmJson 추가
        response.data = response.data.map(data => {
          return {
            ...data,
            tbmJson: tbmJson[data.id] || undefined
          }
        });
      }

      return response;
    },

    convertList (response) {
      const steps = ['등록', '입문', '작업중', '작업완료', '출문']
      const stepsColor = ['#00CFE8', '#FF9F43', '#EA5455', '#28C76F', '#3C3C3C']

      const { data, current_page, last_page, total } = response;
      this.page = current_page;
      this.lastPage = last_page;
      this.total = total;

      return data.map((item) => {
        const tbmJson = item.tbmJson || undefined;
        const body = JSON.parse(item.post_content).body;

        let tbmUsed = false;
        let tbmHtml = `<span style="color:#EA5455">미진행</span>`;
        if (tbmJson) {
          tbmUsed = true;
          const body = tbmJson.body;
          const 참석자명단 = body.참석자명단;
          const 사진대지 = body.photoList.filter(e => (e.id));
          const TBM실시시간 = body.TBM정보.TBM실시시간;

          if (참석자명단.length > 0 && 사진대지.length > 0 && TBM실시시간.eTime) {
            tbmHtml = `<span style="color:#28C76F">완료</span>`
          }
        }

        return {
          'postId': item.id,
          'boardId': item.board_id,
          'zone': body.작업정보.작업구역.zone,
          'region': body.작업정보.작업구역.region,
          'field_id': body.stdInfo.field_id,
          '사업장명': body.stdInfo.field_name,
          '상태': { type: "colorBox", color: stepsColor[body.상태], text: steps[body.상태] },
          '작업시작일시': body.작업허가.작업시작일시,
          '시작시간': body.작업허가.작업시간.시작,
          '종료시간':  body.작업허가.작업시간.종료,
          'tbmHtml': tbmHtml,
          'tbmUsed': tbmUsed,
          '구분': body.작업구분,
          '업체명': body.작업정보.업체명.com_name,
          '작업허가명': body.작업정보.작업허가명,
          '허가번호': body.작업정보.허가번호,
          '관리감독자': body.안전관계자.동국제강.name,
          '작업장소': `${body.작업정보.작업구역.region.name} ${body.작업정보.작업구역.zone.name}`,
          '작업내용': body.작업정보.작업내용,
          '작업유형': body.inspectChecked.join(', '),
          '밀폐공간작업여부': body.inspectChecked.includes('밀폐공간 작업'),
          '안환팀': `${body.안전관계자.확인자유무}`.toUpperCase(),
          '연장작업': body.작업허가.작업시간.연장,
          '작성자': body.stdInfo.writer_name,
        };
      });
    },

    onClickClose() {
      this.showPopup = false;
    },
    onClickUse() {
      this.showPopup = false;
      this.$emit("select", this.selectPost);
    },
  }
};
</script>

<style scoped lang="scss">
.popup-daily-safe-work-permit::v-deep {
  .vs-popup {
    width: 90% !important;
    max-width: 90% !important;
  }

  .vs-con-table.stripe .tr-values.active {
    background: rgb(102, 112, 203) !important;
    color: #fff;
    font-weight: bold;
  }
  .vs-con-table.stripe .tr-values.disabled {
    background: rgba(0, 0, 0, 0.1) !important;
  }

}
</style>
